import styled, { css } from 'styled-components';
import { mobile_xs } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

const Main = styled.div`
  max-width: 662px;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  margin: auto;
  border-radius: var(--border-radius-8);
  margin-bottom: var(--space-24);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  .loading-animation {
    overflow: hidden;
  }
  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }
  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;
const Row = styled.div`
  padding: var(--space-16) var(--space-20);
  border-bottom: 0.5px solid var(--border-primary);
  ${FlexBetween}
  gap: var(--space-12);
  :last-child {
    border-bottom: none;
  }
`;

const LeftDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;
const Profile = styled.div`
  width: 32px;
  height: 32px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
`;

const Line = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
`;

const FirstLine = styled.div`
  width: 80px;
  height: 10px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
`;

const SecondLine = styled.div`
  width: 186px;
  height: 10px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  ${mobile_xs(css`
    width: 140px;
  `)}
`;
const Square = styled.div`
  width: 16px;
  height: 16px;
  border-radius: var(--border-radius-4);
  background-color: var(--background-muted);
`;
const RightDiv = styled.div`
  width: 16px;
  height: 16px;
`;
export { Main, Row, LeftDiv, Profile, Line, FirstLine, SecondLine, Square, RightDiv };
